import { Box, Paper } from "@mui/material";
import { Tabs } from "components/layout";
import Users from "./Users";
import { useEffect, useRef, useState } from "react";
import styles from './SettingPage.module.css';
import { useGetGrantsQuery, useGetUsersQuery, useLazyGetUsersQuery } from "services/data/userApi";
import { HidingError } from "components/errors";




const SettingPage = ({setActiveToolbar}) => {

  useEffect( () => setActiveToolbar('setting'), []);

  const usersRef = useRef(null);
   
  return (
      <Box sx={{maxHeight: '100%'}}>
        <Tabs className={styles.tabPanel}>
          <Users key='users' value='users' title='Пользователи' ref={usersRef} />
        </Tabs>
      </Box>
  )
};

export default SettingPage;